"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var InActiveSaveFiltersIcon = function () {
    return (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "27.999", height: "29.252", viewBox: "0 0 27.999 29.252" },
        react_1.default.createElement("path", { d: "M3873.456-3211.927l-6.552-6.55a.631.631,0,0,1-.177-.431v-.519a10.548,10.548,0,0,1-7.166,2.8,10.49,10.49,0,0,1-7.469-3.094,10.488,10.488,0,0,1-3.093-7.468,10.512,10.512,0,0,1,2.937-7.311,10.512,10.512,0,0,1,7.146-3.241,8.688,8.688,0,0,0-.084,1.206c0,.139,0,.282.012.425a8.891,8.891,0,0,0-5.949,2.783,8.9,8.9,0,0,0-2.437,6.138,8.879,8.879,0,0,0,2.615,6.321,8.878,8.878,0,0,0,6.322,2.616,8.864,8.864,0,0,0,5.38-1.8,9,9,0,0,0,3.179-4.554,10.406,10.406,0,0,0,1.564.434,10.622,10.622,0,0,1-2.369,4.145h.523a.61.61,0,0,1,.432.178l6.55,6.551a.611.611,0,0,1,0,.864l-.5.5a.607.607,0,0,1-.432.179A.6.6,0,0,1,3873.456-3211.927Zm-5.632-15.566-5.481-5.585a4.728,4.728,0,0,1,.331-6.912,4.705,4.705,0,0,1,6.325.469,4.707,4.707,0,0,1,6.325-.469,4.733,4.733,0,0,1,.331,6.916l-5.481,5.584A1.626,1.626,0,0,1,3869-3227,1.641,1.641,0,0,1,3867.824-3227.493Z", transform: "translate(-3849 3241)", fill: "#008272", fillOpacity: "0.25" })));
};
exports.default = react_1.memo(InActiveSaveFiltersIcon);
